const nameRegex = /^[\u4e00-\u9fa5a-zA-Z]+$/;
// 所谓vue的插件，就是一个js对象
const myplugin = {
    install: function(Vue, Options) {
        // 添加属性与方法
        // 这里我写的$testProp等加了$符号的，表示他为vue全局的，但实际上不加也可以的，访问时也不加就行了
        // Vue.prototype.$myoption = '我是来自插件的属性',
        // Vue.prototype.$myfn = function() {
        //     console.log('我是来自插件的方法');
        // };
        // // 添加全局混入
        // Vue.mixin({
        //     mounted() {
        //         console.log('组件创建成功');
        //     },
        // });
        // // 添加全局指令
        // Vue.directive('dir', {
        //     inserted: function(ele) {
        //         ele.style.border = '2px solid green';
        //     },
        // });
        Vue.directive('idcard-format', {
            bind: function(el, binding, vnode) {
                el.addEventListener('input', function(e) {
                    let cursorPosition = e.target.selectionEnd;
                    const value = e.target.value.replace(/[^A-Z0-9]/g, '').replace(/(^(\d{6})|(\d{8}))(?=[^\s])/g, '$1 ').trim();
                    e.target.value = value;
                    if (value.charAt(cursorPosition - 1) === ' ') {
                        cursorPosition++;
                    }
                    e.target.setSelectionRange(cursorPosition, cursorPosition);
                });
            },
        });
        Vue.directive('name-validator', {
            bind: function(el, binding, vnode) {
                el.addEventListener('input', function(event) {
                    const input = event.target.value;
                    if (!nameRegex.test(input)) {
                        event.target.value = input.replace(/[^\u4e00-\u9fa5a-zA-Z]/g, '');
                    }
                });
            },
        });
    },
};
export default myplugin;
